import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { DocumentHistory } from '../models/DocumentHistory';
import { HistoryBaseService } from '../../services/history-base.service';

@Injectable()
export class DocumentHistoryService extends HistoryBaseService<DocumentHistory> {
  /**
   *
   */
  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string
  ) {
    super(http, rootUrl, 'DocumentHistorys', 'History');
  }
}
